import { render } from "./CareGiverLanding.vue?vue&type=template&id=26db1008&scoped=true"
import script from "./CareGiverLanding.vue?vue&type=script&lang=js"
export * from "./CareGiverLanding.vue?vue&type=script&lang=js"

import "./CareGiverLanding.vue?vue&type=style&index=0&id=26db1008&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26db1008"]])

export default __exports__